import React from 'react';
import { IconButton } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { sxConfig } from './interface.style';

const DrillArrow = ({ onClick }) => {
  return (
    <IconButton onClick={onClick} sx={sxConfig.drillArrowIconButton}>
      <EastIcon sx={sxConfig.drillArrowIcon} />
    </IconButton>
  );
};

export default DrillArrow;
